import React from "react"
import Helmet from "react-helmet"
import { Row, Col } from "antd"
import Footer from "../common/footer"
import Subscribe from "../components/subscribe/"
import { Hero } from "../components/hero"
import Layout from "../common/layout"
import Navigation from "../common/navigation"
import heroBG from "../assets/images/solutions/residential/heroBG.png"
import create_modern from "../assets/images/solutions/residential/create-modern.png"
import current_access_icon from "../assets/images/solutions/current_access_icon.svg"
import delightful from "../assets/images/solutions/commercial/delightful.svg"
import manage_multiple_sites from "../assets/images/solutions/manage_multiple_sites.png"
import manage_multiple from "../assets/images/icons/manage_multiple.svg"
import remote_management from "../assets/images/icons/remote_management.svg"
import high_security from "../assets/images/solutions/high_security.svg"
import two_factor_auth from "../assets/images/solutions/two_factor_auth.svg"
import encrypted_access from "../assets/images/solutions/encrypted_access.svg"
import fast_entollment from "../assets/images/icons/fast_entollment.svg"
import real_time_activity_feed from "../assets/images/icons/real_time_activity_feed.svg"
import visual_verification from "../assets/images/solutions/visual_verification.svg"
import auditing from "../assets/images/icons/auditing.svg"
import HelmetScript from "../common/helmetScripts"
import "aos/dist/aos.css"
import "./index.scss"
import "../assets/styles/gallery-grid.scss"
import "../assets/styles/gallery-line.scss"
class SolutionsEnterprise extends React.Component {
  componentDidMount() {
    const AOS = require("aos")
    this.aos = AOS
    this.aos.init()
  }

  componentDidUpdate() {
    this.aos.refresh()
  }
  render() {
    return (
      <Layout location={this.props.location}>
        <Navigation />
          <HelmetScript />
          <Helmet title="Swiftlane Access Control for Residential Buildings">
            <html lang="en" />
            <meta
              name="description"
              content="Swiftlane Access Control provides residential buildings with high security access, easy tenant access management, reduce friction of key fobs and allow modern communities"
            ></meta>
            <meta
              name="keywords"
              content="Swiftlane Access Control for Residential Buildings, access control."
            />
          </Helmet>
        <Hero
          info="SWIFTLANE FOR RESIDENTIAL ACCESS"
          customClass="residential"
          bg={heroBG}
          title="High Security and Easy Tenant Management for Residential Buildings"
          subTitle="Swiftlane face recognition and mobile access creates a world class tenant experience and protects people and assets"
          getAQuote="Get a Quote"
        />
        <div className="wrapper products-page">
          <div className="home-content container homePage-design">
            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={current_access_icon} alt="Door Icon" />
                  </div>
                  <h2>Create Modern Living Spaces</h2>
                  <h3>
                    Swiftlane provides the most seamless access experience for
                    residential living
                  </h3>
                  <ul>
                    <li>Mobile phone based access</li>
                    <li>Face Recognition access</li>
                    <li>Just walk up to the door and the door unlocks</li>
                  </ul>
                </Col>
                <Col md={12} className="text-right">
                  <img src={create_modern} alt="mobile" />
                </Col>
              </Row>
            </div>
            {/* end of box */}

            <section className="gallery-section oldDesign">
              <div className="container">
                <div className="top-icon">
                  <img src={delightful} alt="Icon" />
                </div>
                <h2>Delightful Access Experience</h2>
                <p>
                  Swiftlane’s access solution provides a convenient and
                  delightful access experience to your users
                </p>
              </div>
            </section>

            <div className="box">
              <Row>
                <Col md={12} className="text-left">
                  <img src={manage_multiple_sites} alt="mobile" />
                </Col>
                <Col md={12} className="text-left">
                  <div className="icon-set">
                    <img src={manage_multiple} alt="Door Icon" />
                  </div>
                  <h2>Manage multiple sites</h2>
                  <h3>
                    Swiftlane’s cloud based system provides management from
                    anywhere in the world, and deployed over a fleet of scalable
                    and distributed servers
                  </h3>
                </Col>
              </Row>
            </div>
            {/* end of box */}

            <section className="gallery-section oldDesign">
              <div className="container">
                <h2>High security for a fraction of the cost</h2>
                <p>
                  Manage high traffic across all your tenants securely, with the
                  Swiftlane unique multi factor access combined with operational
                  intelligence
                </p>
                <Row gutter={24}>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={fast_entollment} alt="Icon" />
                    <h4>Easy enrollment</h4>
                    <p>
                      Enroll your users from your desk, no need to make a trip
                      to the server room
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={real_time_activity_feed} alt="Icon" />
                    <h4>Real time activity feed</h4>
                    <p>
                      Watch realtime access activity and visually verify every
                      person’s face
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={visual_verification} alt="Icon" />
                    <h4>Visual Verification</h4>
                    <p>
                      Visual verification at the door prevents unauthorized access
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={auditing} alt="Icon" />
                    <h4>Auditing and Analytics</h4>
                    <p>
                      Identify anomalies and respond to events faster than ever
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={remote_management} alt="Icon" />
                    <h4>Remote Management</h4>
                    <p>Manage your sites live from anywhere</p>
                  </Col>
                  <Col lg={12} md={12} sm={12} xs={24}>
                    <img src={auditing} alt="Icon" />
                    <h4>Detailed roles and permissions</h4>
                    <p>
                    Easily manage multiple tenants from a single dashboard
                    </p>
                  </Col>
                </Row>
              </div>
            </section>

            <section className="gallery-line">
              <div className="container">
                <Row gutter={24} type="flex" justify="space-around" align="top">
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={high_security} alt="Icon" />
                      <h4>High Security</h4>
                      <p>
                        Encrypted mobile unlocks, high security face recognition
                        access
                      </p>
                    </div>
                  </Col>
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={two_factor_auth} alt="Icon" />
                      <h4>Two Factor authentication</h4>
                      <p>
                        Combine face + mobile access to get strong two factor
                        authentication
                      </p>
                    </div>
                  </Col>
                  <Col lg={8} md={12} sm={12} xs={24}>
                    <div className="box">
                      <img src={encrypted_access} alt="Icon" />
                      <h4>Encrypted Access</h4>
                      <p>Reduce dependence on easy to clone proximity cards</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </section>
          </div>
        </div>
        <Subscribe location={this.props.location} />
        <Footer />
      </Layout>
    )
  }
}

export default SolutionsEnterprise
